<template>
  <div>
    <h1 class="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">ตั้งค่า</h1>

    <div class="space-y-6">
      <!-- Store Info Settings -->
      <div class="bg-white rounded-lg shadow p-4 sm:p-6">
        <h2 class="text-lg sm:text-xl font-bold mb-4">ข้อมูลร้านค้า</h2>
        <div v-if="loading" class="text-center py-8 text-gray-500">กำลังโหลด...</div>
        <form v-else @submit.prevent="updateStoreInfo" class="max-w-xl">
          <div class="space-y-4">
            <div>
              <label class="block text-gray-700 mb-1 text-sm sm:text-base">ชื่อร้านค้า</label>
              <input 
                v-model="storeForm.shop_name" 
                type="text" 
                class="w-full border rounded px-3 sm:px-4 py-2 text-sm sm:text-base focus:ring-2 focus:ring-primary focus:border-primary" 
                placeholder="ชื่อร้านค้าของคุณ"
              />
            </div>
            <button 
              type="submit" 
              class="bg-primary text-white px-6 py-2 rounded font-bold hover:bg-primary-dark disabled:opacity-50 text-sm sm:text-base"
              :disabled="savingStore"
            >
              {{ savingStore ? 'กำลังบันทึก...' : 'บันทึก' }}
            </button>
          </div>
        </form>
      </div>

      <!-- Shipping Settings -->
      <div class="bg-white rounded-lg shadow p-4 sm:p-6">
        <h2 class="text-lg sm:text-xl font-bold mb-4">การจัดส่ง</h2>
        <div v-if="loading" class="text-center py-8 text-gray-500">กำลังโหลด...</div>
        <form v-else @submit.prevent="updateShipping" class="max-w-xl">
          <div class="space-y-4">
            <div>
              <label class="block text-gray-700 mb-1 text-sm sm:text-base">ค่าจัดส่งปกติ (บาท)</label>
              <input 
                v-model="shippingForm.shipping_fee" 
                type="number" 
                min="0"
                class="w-full border rounded px-3 sm:px-4 py-2 text-sm sm:text-base focus:ring-2 focus:ring-primary focus:border-primary" 
                placeholder="0"
              />
            </div>
            <div>
              <label class="block text-gray-700 mb-1 text-sm sm:text-base">ยอดขั้นต่ำส่งฟรี (บาท)</label>
              <input 
                v-model="shippingForm.free_shipping_threshold" 
                type="number" 
                min="0"
                class="w-full border rounded px-3 sm:px-4 py-2 text-sm sm:text-base focus:ring-2 focus:ring-primary focus:border-primary" 
                placeholder="0 = ไม่มีส่งฟรี"
              />
              <p class="text-gray-500 text-xs mt-1">ใส่ 0 หากไม่ต้องการให้มีส่งฟรี</p>
            </div>
            <button 
              type="submit" 
              class="bg-primary text-white px-6 py-2 rounded font-bold hover:bg-primary-dark disabled:opacity-50 text-sm sm:text-base"
              :disabled="savingShipping"
            >
              {{ savingShipping ? 'กำลังบันทึก...' : 'บันทึก' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '../../api';
import { useNotification } from '../../composables/useNotification';

const { showSuccess, showError, handleApiError } = useNotification();

const loading = ref(true);
const savingStore = ref(false);
const savingShipping = ref(false);

const storeForm = ref({
  shop_name: ''
});

const shippingForm = ref({
  shipping_fee: '',
  free_shipping_threshold: ''
});

onMounted(async () => {
  try {
    const response = await api.get('/admin/settings');
    const data = response.data.data || {};
    
    storeForm.value = {
      shop_name: data.shop_name || ''
    };
    
    shippingForm.value = {
      shipping_fee: data.shipping_fee || '',
      free_shipping_threshold: data.free_shipping_threshold || ''
    };
  } catch (error) {
    showError('ไม่สามารถโหลดข้อมูลการตั้งค่าได้');
  } finally {
    loading.value = false;
  }
});

const updateStoreInfo = async () => {
  savingStore.value = true;
  try {
    const settings = {
      shop_name: String(storeForm.value.shop_name || '')
    };
    await api.post('/admin/settings', { settings });
    showSuccess('บันทึกข้อมูลร้านค้าเรียบร้อยแล้ว');
  } catch (error) {
    handleApiError(error);
  } finally {
    savingStore.value = false;
  }
};

const updateShipping = async () => {
  savingShipping.value = true;
  try {
    const settings = {
      shipping_fee: String(shippingForm.value.shipping_fee || '0'),
      free_shipping_threshold: String(shippingForm.value.free_shipping_threshold || '0')
    };
    await api.post('/admin/settings', { settings });
    showSuccess('บันทึกการตั้งค่าการจัดส่งเรียบร้อยแล้ว');
  } catch (error) {
    handleApiError(error);
  } finally {
    savingShipping.value = false;
  }
};
</script>
